<template lang="pug">
div
  .divider(v-if="mensagens.length")
  .mt-2.p-2.small.mensagem-box(
    v-for="mensagem in mensagens",
    :key="mensagem.id"
  )
    show-mensagem(:mensagem="mensagem")
  .py-2
    a.c-hand.text-small(v-if="last.mensagem_id && !loading", @click="loadMore") Carregar mensagem anterior...
</template>

<script>
import recebidas from "@/api/mensagens/recebidas";
import enviadas from "@/api/mensagens/enviadas";
import Mensagem from "@/models/Mensagem";
import parseErrors from "@/lib/errors/parseErrors";
import User from "@/lib/User";
import ShowMensagem from "./Mensagem.vue";

const apis = { recebidas, enviadas };

export default {
  auth: {
    state: ["usuario"],
  },
  components: { ShowMensagem },
  data() {
    return { mensagens: [], loading: false };
  },
  computed: {
    nextRequestApiName() {
      if (this.pessoa.id === this.last.remetente_id) return "recebidas";
      return "enviadas";
    },
    last() {
      const length = this.mensagens.length;
      if (length) return this.mensagens[length - 1];
      return this.mensagem;
    },
    pessoa() {
      if (!User.current) return {};
      return User.current.pessoa;
    },
  },
  props: { mensagem: { type: Object, required: true } },
  methods: {
    async loadMore() {
      try {
        this.loading = true;
        const api = apis[this.nextRequestApiName];
        const mensagem = await api.one(this.last.mensagem_id);
        this.mensagens.push(new Mensagem(mensagem));
      } catch (e) {
        this.$toaster.error(parseErrors(e).join(", "));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.mensagem-box {
  background-color: var(--gray-lighter);
  border-radius: 5px;
}
</style>
